import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=0fb66a03&scoped=true"
import script from "./info-card.vue?vue&type=script&lang=js"
export * from "./info-card.vue?vue&type=script&lang=js"
import style0 from "./info-card.vue?vue&type=style&index=0&id=0fb66a03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb66a03",
  null
  
)

export default component.exports